<template>
  <div class="small-form-grid">
    <div class="grid-x grid-padding-x">
      <div class="cell auto">
        <label for="Katalognr">Katalognr *</label>
        <div class="input-container disabled">
          <input id="Katalognr" type="text" :value="objekt.Katalognr || 'Mangler…'" disabled>
        </div>
      </div>
      <div class="cell shrink">
        <label for="Budnr">Spadenr</label>
        <div class="input-container disabled">
          <input v-if="bid.Budnr" id="Budnr" type="text" :value="bid.Budnr" disabled>
          <input v-else id="Budnr" type="text" :value="'Settes automatisk…'" disabled>
        </div>
      </div>

      <TheIntegerInput
        v-model.trim="form.Bud"
        label="Forhåndsbud"
        containerClassName="cell large-12"
        name="Bud"
        symbol="kr"
        maxlength="10"
        required
        v-validate="rulesBud"
        :hideErrorMsg="true"
      />

      <TheAutoCompleteInput
        v-model.trim="customer.parsed_name"
        containerClassName="cell small-12"
        name="Kunde"
        :placeholder="'Søk budgiver…'"
        :label="'Budgiver'"
        :onInputCallback="onKundeSearchInput"
        :onSelectCallback="onKundeSearchSelected"
        :onResetCallback="onKundeSearchReset"
        :debounce="1250"
        :minquery="2"
        :hideErrorMsg="true"
      >
        <label slot="label">
          Budgiver * (<a href="javascript:;" @click="showCustomerModal()">Ny kunde</a>)
        </label>
        <div slot="item" slot-scope="props">
          <strong>{{props.item.Kundenr}}</strong>
          <span v-if="props.item.Bedrift">{{ props.item.FirmaNavn || props.item.full_name }}</span>
          <span v-else>{{ props.item.full_name }}</span>
        </div>
      </TheAutoCompleteInput>

      <div class="cell large-12">
        <input type="hidden" name="Kundenr" v-model="customer.Kundenr" v-validate="rulesCustomer"/>
        <dl class="small-box horizontal" v-if="customer.Kundenr">
          <dt>Kundenr</dt>
          <dd>{{customer.Kundenr}}</dd>

          <dt>Navn</dt>
          <dd>{{customer.parsed_name}}</dd>

          <dt>Mobil</dt>
          <dd>{{customer.Mobil || '-'}}</dd>

          <dt>Tlf. privat</dt>
          <dd>{{customer.Tlfprivat || '-'}}</dd>

          <dt>Tlf. arbeid</dt>
          <dd>{{customer.Tlfarbeid || '-'}}</dd>
        </dl>
      </div>

      <div class="cell">
        <div class="input-container" style="margin-bottom:1rem">
          <label for="objektNotat">Merknad * (Legg inn dato og tidspunkt for forhåndsbud)</label>
          <textarea
            rows="2"
            autocomplete="off"
            placeholder="Legg til merknad…"
            v-model="form.Merknad"
            v-validate="'required|max:500'"
            name="Merknad"
            id="Merknad"
            :class="{ 'error': errors.has('Merknad') }"></textarea>
        </div>
      </div>

      <div class="cell large-12" v-if="errors.all().length > 0">
        <div class="panel small error">
          <ul>
            <li v-if="errors.has('Budnr')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{errors.first('Budnr')}}
            </li>
            <li v-if="errors.has('Bud')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{errors.first('Bud')}}
            </li>
            <li v-if="errors.has('Kundenr')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              Du må velge en budgiver...
            </li>
            <li v-if="errors.has('Merknad')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{errors.first('Merknad')}}
            </li>
          </ul>
        </div>
      </div>

      <div class="cell auto">
        <div class="input-container checkbox">
          <input v-model="form.SendEmail" type="checkbox" name="SendEmail" id="SendEmail">
          <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>

            <label for="SendEmail">Send kvittering til kunde på e-post</label>
        </div>
      </div>

      <template v-if="loading || !objekt.Katalognr">
        <div class="cell shrink">
          <button type="submit" class="button small primary disabled">Lagre</button>
        </div>
      </template>
      <template v-else-if="changed">
        <div class="cell shrink">
          <button v-if="bid.Budnr && !deleting" @click="removeConfirm" type="button" class="button small primary transparent">Slett</button>

          <button v-if="!saving" @click="handleSubmit" type="submit" class="button small primary">Lagre</button>
          <button v-else type="submit" class="button small primary loading">Lagre <span class="loader-spinner"></span></button>
        </div>
      </template>
      <template v-else>
        <div class="cell shrink">
          <button v-if="bid.Budnr && !deleting" @click="removeConfirm" type="button" class="button small primary transparent">Slett</button>

          <button type="submit" class="button small primary disabled">Lagre</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import KundeService from '@/services/KundeService'
import AuksjonService from '../../../../services/AuksjonService'
import TheAutoCompleteInput from '../../../Inputs/TheAutoCompleteInput'

export default {
  name: 'TheSidebarModule',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput
  },
  props: {
    item: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      saving: false,
      deleting: false,
      objekt: {},
      bid: {},
      form: {},
      orig: {},
      customer: {}
    }
  },
  computed: {
    changed: function () {
      return !this._.isEqual(this.form, this.orig)
    },
    rulesBud: function () {
      return {
        required: true
      }
    },
    rulesCustomer: function () {
      return {
        required: true,
        min: 1
      }
    }
  },
  watch: {
    item: function (newVal) {
      this.initObject()
    }
  },
  created () {
    bus.$off('kunde_form_saved')
  },
  mounted () {
    bus.$on('kunde_form_saved', (data) => this.onKundeCreated(data))

    this.initObject()
  },
  methods: {
    revalidateCustomer: function () {
      const vm = this
      setTimeout(function () {
        vm.$validator.validate('Kundenr')
      })
    },
    showCustomerModal: function () {
      this.openModal('kunde-card-create-modal')
    },
    onKundeSearchInput: function (query) {
      return KundeService.search(query)
    },
    onKundeCreated: function (data) {
      this.customer = data
      this.form.Kundenr = data.Kundenr
      this.closeModal()
      this.revalidateCustomer()
    },
    onKundeSearchReset: function () {
      this.customer = {}
      this.form.Kundenr = ''
      this.revalidateCustomer()
    },
    onKundeSearchSelected: function (item) {
      this.customer = item || {}
      this.form.Kundenr = String(item.Kundenr || '')
      this.revalidateCustomer()
    },
    initObject: function () {
      // Set object
      this.objekt = this._.cloneDeep(this.item.obj || {})

      // Set current bid if have any...
      this.bid = this._.cloneDeep(this.objekt.forhandsbud || {})

      // Make original and form
      this.orig = {
        Bud: String(this.bid.Bud || ''),
        Kundenr: String(this.bid.Kundenr || ''),
        Merknad: String(this.bid.Merknad || ''),
        SendEmail: !this.bid.Forhbudid
      }

      this.form = this._.cloneDeep(this.orig)

      if (this.bid.kunde) {
        this.customer = this._.cloneDeep(this.bid.kunde)
      } else {
        this.customer = {}
      }

      // Clear error bag
      this.errors.clear()
    },
    handleSubmit: function () {
      const vm = this

      if (this.saving || !this.changed) {
        return
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
          } else if (this.bid.Forhbudid) {
            this.openConfirm(
              'Forhåndsbud',
              'Er du sikker på at du vil endre?',
              'Ja',
              'Nei',
              function () {
                vm.closeModal()
                vm.update()
              },
              function () {
                vm.closeModal()
              }
            )
          } else {
            this.create()
          }
        })
    },
    create: function () {
      this.saving = true

      // Copy form data and add what's need for save
      const save = Object.assign(
        {},
        this._.cloneDeep(this.form),
        {
          Auksjon: this.objekt.Auksjon,
          Kontraktnr: this.objekt.Kontraktnr,
          Lopenr: this.objekt.Lopenr,
          Katalognr: this.objekt.Katalognr,
          Katbnr: this.objekt.Katbnr,
          Objektid: this.objekt.Objektid,
          Avdelingsid: this.objekt.Avdelingsid
        }
      )

      AuksjonService.createForhandsbud(save)
        .then(response => {
          if (!response.data.mail) {
            // Show error about email sending
            this.$helpers.showWarningAlert('Feil', 'Forhåndsbud lagret, men kunne ikke sende e-post til kunde.')
          }

          this.$emit('on-save', response.data.item)
        })
        .catch(error => {
          console.log('Error', error)
          const custom = this.$helpers.getCustomErrors(error)
          if (this._.has(custom, 'Katalognr._empty')) {
            this.$helpers.showErrorAlert('Feil', 'Objekt har ingen katalognr.')
          } else {
            this.$helpers.showErrorAlert('Feil', 'Noe gikk feil i lagringen.')
          }
        })
        .then(() => {
          this.saving = false
        })
    },
    update: function () {
      this.saving = true

      const save = this._.cloneDeep(this.form)

      AuksjonService.updateForhandsbud(this.bid.Forhbudid, save)
        .then(response => {
          if (!response.data.mail) {
            // Show error about email sending
            this.$helpers.showWarningAlert('Feil', 'Forhåndsbud lagret, men kunne ikke sende e-post til kunde.')
          }

          this.$emit('on-save', response.data.item)
        })
        .catch(error => {
          console.log('Error', error)
          const custom = this.$helpers.getCustomErrors(error)

          if (this._.has(custom, 'Katalognr._empty')) {
            this.$helpers.showErrorAlert('Feil', 'Objekt har ingen katalognr.')
          } else {
            this.$helpers.showErrorAlert('Feil', 'Noe gikk feil i lagringen.')
          }
        })
        .then(() => {
          this.saving = false
        })
    },
    removeConfirm: function () {
      const vm = this
      this.openConfirm(
        'Ønsker du å slette dette forhåndsbud?',
        'Denne handlingen kan ikke angres.',
        'Ja',
        'Nei',
        function () {
          vm.closeModal()
          vm.remove()
        },
        function () {
          vm.closeModal()
        }
      )
    },
    remove: function () {
      this.deleting = true

      AuksjonService.deleteForhandsbud(this.bid.Forhbudid)
        .then(response => {
          this.$emit('on-delete', {
            Objektid: this.objekt.Objektid,
            Forhbudid: this.bid.Forhbudid
          })
        })
        .catch(error => {
          console.log('Error', error)
          this.$helpers.showErrorAlert('Feil', 'Noe gikk feil i lagringen.')
        })
        .then(() => {
          this.deleting = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Forhandsbud/TheSidebarModule.vue